const SITE_URL = 'https://whoplays.us';

type BreadcrumbItem = {
  name: string;
  path: string;
};

export function buildBreadcrumbJsonLd(items: BreadcrumbItem[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}

export const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'WhoPlays US',
  url: SITE_URL,
  logo: `${SITE_URL}/apple-touch-icon.png`,
  sameAs: [
    'https://www.instagram.com/whoplaysus/',
    'https://www.facebook.com/profile.php?id=61550796384597',
    'https://www.youtube.com/channel/UC9JuYJ_QR3ykzjXgnKIRviA',
    'https://www.linkedin.com/company/whoplays-us-inc/?viewAsMember=true',
    'https://tiktok.com/@whoplays05',
  ],
};
